import {
  createPersistedStorage as createPersistedStorageBase,
  type PersistedStorageOptions as BaseOptions,
} from '@localagent/jotai-utils';

export type PersistedStorageOptions<T> = BaseOptions<T>;

export function createPersistedStorage<T>(options: PersistedStorageOptions<T>) {
  return createPersistedStorageBase<T>(options);
}
